module.exports = __webpack_public_path__ + "static/pongPreview.1953105f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pongPreview.png
// module id = 468
// module chunks = 44780966157200